import { useState, useEffect } from "react";
import { Modal, Table, Radio, Button } from "antd";
import {
  RepresentationDocumentNumberCell,
  components,
} from "@entities/journal";
import { fallbackString, formatDate } from "@shared/utils";


type Permission = components["schemas"]["DocumentationPermission"];

type Props = {
  open: boolean;
  onClose: () => void;
  onSelect: (selected: Permission) => void;
  permissions: Permission[];
  title?: string;
};

export const RepresentationDocumentationPermissionModal = ({
  open,
  onClose,
  onSelect,
  permissions,
  title = "Выберите разрешение на строительство",
}: Props) => {
  const [selectedId, setSelectedId] = useState<string | null>(null);

  useEffect(() => {
    const defaultSelected = permissions.find(
      (p) => p.selectedDocumentPermission,
    );
    setSelectedId(defaultSelected?.documentationPermissionId ?? null);
  }, [permissions]);

  const handleSelect = () => {
    const selected = permissions.find(
      (p) => p.documentationPermissionId === selectedId,
    );
    if (selected) onSelect(selected);
  };

  const columns = [
    {
      title: "",
      dataIndex: "documentationPermissionId",
      render: (id: string) => (
        <Radio checked={selectedId === id} onChange={() => setSelectedId(id)} />
      ),
      width: 50,
    },
    {
      title: "№ разрешения",
      dataIndex: "number",
      render: (number: string, record: Permission) => (
        <RepresentationDocumentNumberCell
          number={number}
          attachment={record.permissionFile}
        />
      ),
    },
    {
      title: "Дата выдачи",
      dataIndex: "date",
      render: (date?: string) => fallbackString(formatDate(date)),
    },
    {
      title: "Наименование органа, выдавшего разрешение",
      dataIndex: "issued",
    },
    {
      title: "Срок действия",
      dataIndex: "expiryDate",
      render: (date?: string) => fallbackString(formatDate(date)),
    },
    {
      title: "Продлено до",
      dataIndex: "prolongDate",
      render: (date?: string) => fallbackString(formatDate(date)),
    },
  ];

  return (
    <Modal
      open={open}
      title={title}
      onCancel={onClose}
      zIndex={1000}
      className="representation-documentation-modal"
      footer={[
        <Button
          key="confirm"
          type="primary"
          onClick={handleSelect}
          disabled={!selectedId}
        >
          Подтвердить выбор
        </Button>,
      ]}
      width={800}
    >
      <Table
        dataSource={permissions}
        columns={columns}
        pagination={false}
        rowKey="documentationPermissionId"
      />
    </Modal>
  );
};
